import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeclarationPublishComponent } from './declaration-publish.component';

@NgModule({
  declarations: [
    DeclarationPublishComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    DeclarationPublishComponent
  ]
})
export class DeclarationPublishModule {}
 
